import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState, Policy } from '@/redux/stores/types'
import { TripTravelPolicy } from '@/travelsuit/policy'
import { GroupTypes } from '@/types/group'

import { IAction } from '../actions/action-helpers'
import { TravelPolicyTypes } from '../actions/actions.types'

type TravelPolicyState = ApplicationState['travelPolicy']

const defaultState: TravelPolicyState = {
	policies: new ImmutableMap(),
	list: new ImmutableMap(),
	ignoredUsers: null,
	byUser: new ImmutableMap(),
}

function travelPolicyReducer(state = defaultState, action: IAction): TravelPolicyState {
	switch (action.type) {
		case TravelPolicyTypes.GetPolicy.SUCCESS: {
			const policy = action.payload
			return {
				...state,
				policies:
					action.requestPayload === 0 ? state.policies.set(0, policy) : state.policies.set(policy.group_id, policy),
			}
		}
		case TravelPolicyTypes.UpdatePolicy.SUCCESS: {
			const policy = action.payload
			return {
				...state,
				policies:
					action.requestPayload.type === GroupTypes.Company
						? state.policies.set(0, policy)
						: state.policies.set(policy.group_id, policy),
			}
		}
		case TravelPolicyTypes.GetAllPolicies.SUCCESS:
			return (action.payload ?? []).reduce(
				(newState: TravelPolicyState, policyMinimal: Policy) => ({
					...newState,
					policies: newState.policies.set(policyMinimal.group_id, policyMinimal),
				}),
				state,
			)
		case TravelPolicyTypes.GetPoliciesByType.SUCCESS: {
			const list = action.payload
			const groupType = action.requestPayload
			return {
				...state,
				list: state.list.set(groupType, list),
			}
		}
		case TravelPolicyTypes.DeletePolicy.SUCCESS: {
			const policyGroupId = action.requestPayload.groupIdForPolicy
			return {
				...state,
				policies: state.policies.delete(policyGroupId),
			}
		}
		case TravelPolicyTypes.GetIgnoredUsers.SUCCESS:
		case TravelPolicyTypes.UpdateIgnoredUsers.SUCCESS:
			return {
				...state,
				ignoredUsers: action.payload,
			}
		case TravelPolicyTypes.CreateCustomPolicy.SUCCESS:
		case TravelPolicyTypes.CreateOfficePolicy.SUCCESS: {
			const policy = action.payload
			return { ...state, policies: state.policies.set(policy.group_id, policy) }
		}
		case TravelPolicyTypes.GetPolicyForUsers.SUCCESS: {
			return (action.payload ?? []).reduce(
				(newState: TravelPolicyState, tripPolicy: TripTravelPolicy) => ({
					...newState,
					byUser: newState.byUser.set(tripPolicy.user.id!, tripPolicy),
				}),
				state,
			)
		}
	}
	return state
}

export default travelPolicyReducer
